import React, { useContext, useMemo } from "react";
import { useState } from "react";
import { searchAPI } from "./../stores/services/amc.service";
import { Modal } from "react-bootstrap";
import { Container, Row, Col, Label, Input, FormGroup } from "reactstrap";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import {
  getFundByAmc,
  getInstrumentType,
  getDailyNavByDate,
  validateFundNav,
} from "./../stores/services/funds.service";
import { getModeOfPayments } from "./../stores/services/transactions.service";
import { getAccountByFund } from "./../stores/services/account.service";
import { getUnitHoldersByAmcAndFolioNo } from "./../stores/services/unit-holder.service";
import { getAllBanks } from "./../stores/services/bank.service";
import { getBranchByBankName } from "./../stores/services/branch.service";
import { RiArrowGoForwardFill } from "react-icons/ri";
import {
  fieldData,
  transactionObj,
  fieldValue,
  chechFieldDisplay,
  getCounterAccount,
  getTaxObj,
  checkTaxBoolean,
} from "./field";
import {
  addMegaTransaction,
  EditTransaction,
  getFlow,
  addConversionOfUnitsTransaction,
} from "./../stores/services/beta-transaction.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { inWords } from "./../stores/services/template.service";
import { getBrokerByType } from "./../stores/services/broker.service";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import {
  numberWithCommas,
  accountTitle_AccountNumber_Regex,
  getLedgerAccounts,
  getLedgersByTxn,
} from "./../utils/customFunction";
import { Link } from "react-router-dom";

import AddUnitHolder from "./add-new-unitholder-txn";
import NumberFormat from "react-number-format";
import { ThemeContext } from "../contexts/ThemeContext";

import {
  getChartOfAccounts,
  getNewChartsOfAccountsByFund,
  getTransactionsLedgers,
} from "./../stores/services/chatofaccounts.service";

import { getAllLedgers } from "../utils/customFunction";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import "./voucher.css";

import { getLedgerInfoByCode } from "../stores/services/chatofaccounts.service";
import { useSelector } from "react-redux";
import { set } from "mobx";

interface FieldValues {
  email: string;
  txnr_type: string;
  amc_code: string;
  fund_code: string;
  instruction_date: string;
  execution_date: string;
  executed_date: string;
  fund_account: string;
  reinvest: string;
  account_title: string;
  period: string;
  account_no: string;
  bank: string;
  branch: string;
  counter_account_type: string;
  counter_type: string;
  counter_account_title: string;
  counter_account_number: string;
  counter_bank: string;
  counter_branch: string;
  mode_of_payment: string;
  payment_type: string;
  instrument_no: string;
  instrument_type: string;
  instrument_date: string;
  realized_date: string;
  realized: string;
  gross_amount: string;
  net_amount: any;
  dr_amount: string;
  cr_amount: string;
  balance: string;
  folio_no: string;
  unitholder_name: string;
  units: string;
  nav: string;
  dividend_date: string;
  dividend_rate: string;
  sale_date: string;
  current_holding: string;
  total_holding: string;
  symbol: string;
  dividend_percentage: string;
  credit_date: string;
  maturity_type: string;
  security_type: string;
  issue_date: string;
  conversion_date: string;
  associated_transaction: string;
  maturity_date: string;
  coupon_rate: string;
  price: string;
  face_value: string;
  money_market_face_value: string;
  detail: string;
  type: string;
  redemption_date: string;
  remain_holding: string;
  settlement_by: string;
  tax_type: string;
  settlement_date: string;
  total_charges: string;
  txn_charges: string;
  sale_txn_no: string;
  return_date: string;
  txn_id: string;
  tenor: string;
  yield: string;
  last_coupon_date: string;
  next_coupon_date: string;
  fund_ips_account: string;
  counter_party_ips_account: string;
  system_tax: string;
  primary_dealer: string;
  broker_commission: string;
  tax_sst: string;
  tax_wht_it: string;
  tax_wht_sst: string;
  tax_cgt: string;
  sale_load: string;
  redemption_load: string;
  low_balance_agree: string;
  offer_price: string;
  load_per_unit: string;
  percentage_of_discount: string;
  applicable_offer_price: string;
  sales_tax_collector: string;
  volume: string;
  par_value: string;
  announcement_date: string;
  bonus_percentage: string;
  bonus_credit_date: string;
  bonus_gross_volume: string;
  tax_it_bonus_amount: string;
  net_bonus_volume: string;
  right_share_percentage: string;
  right_share_credit_date: string;
  right_share_gross_volume: string;
  tax_it_right_share_amount: string;
  net_right_share_volume: string;
  tax_on_dvidend: string;
  tax_on_bonus: string;
  tax_on_right: string;
  zakat_amount: string;
  ledgers: string;
}

const Vouchers = (props: any) => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const history = useHistory();
  const context = useContext(ThemeContext);
  const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const token = sessionStorage.getItem("token") || "";
  const [headLabel, setHeadLabel] = React.useState("");
  const tx = sessionStorage.getItem("rejectedTxName") || "";
  const amcEdit = sessionStorage.getItem("rejectedAmc") || false;
  const [amcdata, setAmcdata] = useState<any>([]);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [accountNoData, setAccountNoData] = useState<any>([]);
  const [MOPData, setMOPData] = useState<any>([]);
  const [iTypeData, setITypeData] = useState<any>([]);
  const [accFundLoading, setAccFundLoading] = useState<boolean>(false);
  const [Loading, setLoading] = useState(false);
  // let txnTypes = JSON.parse(sessionStorage.getItem("txnType") || "");
  let txnTypes = useSelector((state: any) => state.txnTypes);
  const requiredFields = transactionObj(headLabel);
  let counterAccounter = getCounterAccount(headLabel);
  let [counterType, setCounterType] = useState("");
  const [accLoading, setAccLoading] = useState(false);
  const [unitHolderData, setUnitHolderData] = useState<any>([]);
  const paymentType = sessionStorage.getItem("payment_type") || "";

  // const chartOfAccounts = useSelector((state: any) => state.chartofAccounts);
  const [chartOfAccounts, setChartOfAccounts] = useState<any>(undefined);
  const [fund, setFund] = useState("");

  const [psxList, setPsxList] = useState<any>([]);
  const [stockMarketDataFund, setStockMarketDataFund] = useState<any>([]); // PSX data of fund
  const [moneyMarketDataFund, setMoneyMarketDataFund] = useState<any>([]); // money market data of fund
  const [borkerByTypeData, setBorkerByTypeData] = useState<any>([]);
  const [securityTypeData, setSecurityTypeData] = useState<any>([]);
  const [taxData, setTaxData] = useState<any>([]);
  const [counterFundAccount, setCounterFundAccount] = useState<any>([]);
  const amcName = sessionStorage.getItem("amc_name") || "";
  let [sstPercentage, setSSTPercentage] = useState("");
  let [whtITPercentage, setWHTITPercentage] = useState("");
  let [sstWHTPercentage, setSSTWHTPercentage] = useState("");

  const [flowLoading, setFlowLoading] = useState<boolean>(false); // will Be true When all Apis give Response
  const [primaryDealerData, setPrimaryDealerData] = useState<any>([]); // Money Maket Securities Hook - primaryDealerData

  //for data checks
  const [fundCheck, setFundCheck] = useState(false);
  const [errorShow, setErrorShow] = useState(false);
  const [accountCheck, setAccountCheck] = useState(false);
  const [brokerCountFlag, setBrokerCountFlag] = useState(false);
  const [toAccountData, setToAccountData] = useState<any>([]); // all Account Numbers  against a Fund
  const [allCounterFunds, setAllCounterFunds] = useState<any>([]); // all Funds Data related to an Amc
  const [allCounterFundsAccounts, setAllCounterFundsAccounts] = useState<any>(
    []
  ); // all Funds Data related to an Amc
  const [stockMarketData, setStockMarketData] = useState<any>([]); // Types For Equity Investment Transaction Data

  const [unitHolderFieldReadOnly, setUnitHolderFieldReadOnly] = useState(false);
  const [loadBtnEnable, setLoadBtnEnable] = useState(false);

  const [viewModalAddNewHolder, setViewModalAddNewUnitHolder] = useState(false);

  const [mmSecurityLoading, setMMSecurityLoading] = useState(false);

  const [propsState, setPropsState] = useState({
    amc_code: "",
    folioNo: "",
    unitholder: "",
    account_title: "",
    account_no: "",
    bank: "",
    branch: "",
  });

  // for legders states
  const [ledgerAccounts, setLegderAccounts] = useState<any>([]);
  const [ledgerAccountCode, setLegderAccountCode] = useState("");
  const [ledgerAccountName, setLegderAccountName] = useState("");

  const [transactionLedgers, setTransactionLedgers] = useState<any>([{}]);

  // const [totalDebit, setTotalDebit] = useState("0");

  //const [totalCredit, setTotalCredit] = useState("0");
  const [balance, setBalance] = useState("0");

  //for voucher debit / credit
  //debit
  const [allLedgerData, setAllLedgerData] = useState<any>([]);
  const [selectedLedgerDebit, setSelectedLedgerDebit] = useState("");
  const [valueSelectedLedgerDebit, setValueSelectedLedgerDebit] =
    React.useState<string | null>("");
  const [inputValueSelectedLedgerDebit, setInputValueSelectedLedgerDebit] =
    React.useState("");
  const [amountDebit, setAmountDebit] = useState<any>("0");
  const [descriptionDebit, setDescriptionDebit] = useState("");
  const [invoiceNumberDebit, setInvoiceNumberDebit] = useState("");
  const [debitFormData, setDebitFormData] = useState<any>([]);
  const totalDebit = useMemo(() => {
    return debitFormData.reduce(
      (total, obj) => total + Number(obj.amount || "0"),
      0
    );
  }, [debitFormData]);

  const [totalDebitCount, setTotalDebitCount] = useState("0");
  const [viewDebitIndex, setViewDebitIndex] = useState("");
  const [editDebitIndex, setEditDebitIndex] = useState(-1);

  //credit
  const [selectedLedgerCredit, setSelectedLedgerCredit] = useState("");
  const [valueSelectedLedgerCredit, setValueSelectedLedgerCredit] =
    React.useState<string | null>("");
  const [inputValueSelectedLedgerCredit, setInputValueSelectedLedgerCredit] =
    React.useState("");
  const [amountCredit, setAmountCredit] = useState<any>("0");
  const [descriptionCredit, setDescriptionCredit] = useState("");
  const [invoiceNumberCredit, setInvoiceNumberCredit] = useState("");
  const [creditFormData, setCreditFormData] = useState<any>([]);
  const totalCredit = useMemo(() => {
    return creditFormData.reduce(
      (total, obj) => total + Number(obj.amount || "0"),
      0
    );
  }, [creditFormData]);
  const [totalCreditCount, setTotalCreditCount] = useState("0");
  const [editCreditIndex, setEditCreditIndex] = useState(-1);
  const [viewCreditIndex, setViewCreditIndex] = useState("");

  //for credit edit
  const [editValueSelectedLedgerCredit, setEditValueSelectedLedgerCredit] =
    React.useState<string | null>("");
  const [
    editInputValueSelectedLedgerCredit,
    setEditInputValueSelectedLedgerCredit,
  ] = React.useState("");
  const [editAmountCredit, setEditAmountCredit] = useState<any>("0");
  const [editDescriptionCredit, setEditDescriptionCredit] = useState("");
  const [editInvoiceNumberCredit, setEditInvoiceNumberCredit] = useState("");

  //for ledger autocomplete
  const [ledgerOption, setLedgerOption] = useState<any>([]);

  //for ledger to send to backend
  // let [sendingLedgers, setSendingLedgers] = useState<any>([]);

  //states for showing error boreders on required fields

  const [fundCodeError, setFundCodeError] = useState<boolean>(false);
  const [instructionDateError, setInstructionDateError] =
    useState<boolean>(false);
  const [settlementDateError, setSettelementDateError] =
    useState<boolean>(false);
  const [modeOfPaymentError, setModeOfPaymentError] = useState<boolean>(false);
  const [instrumentTypeError, setInstrumentTypeError] =
    useState<boolean>(false);

  const getFundByAMcCode = async (code: string) => {
    if (counterAccounter === "Fund") {
      clearCounterAccountFields();
    }
    setAccountCheck(false);
    setMMSecurityLoading(true);
    setAccFundLoading(true);
    allFunds.length = 0;
    setAllFunds(allFunds);
    // accountNoData.length = 0;
    // setAccountNoData(accountNoData);
    // setToAccountData(accountNoData);
    if (!flag) {
      clearFundAccountFields();
    }
    //get funds by amc for dropdown
    try {
      const response = await getFundByAmc(
        email,
        code,
        fund_code?.length > 0 ? fund_code : ""
      );
      // sort data
      let sortedData: any = [];
      sortedData = response.data.data.sort(function (a, b) {
        let x = a.nature.toLowerCase();
        let y = b.nature.toLowerCase();
        if (x > y) {
          return 1;
        }
        if (x < y) {
          return -1;
        }
        return 0;
      });
      // setAllFunds(response.data.data);
      setAllFunds(sortedData);
      let temp = sortedData.map((val) => {
        if (val.nature === "Special Managed Account") {
          return {
            ...val,
            label: `${val.fund_name} (${val.symbol_code}) - ${"SMA"} `,
            value: val.symbol_code,
          };
        } else {
          return {
            ...val,
            label: `${val.fund_name} (${val.symbol_code})`,
            value: val.symbol_code,
          };
        }
      });
      setAllCounterFunds(temp);
      setStockMarketData([]);
      if (response.data.data.length < 1) {
        setFundCheck(true);
      } else {
        setFundCheck(false);
      }
      setAccFundLoading(false);
    } catch (error) {}
  };

  const getAccountByFundName = async (fund_code: string) => {
    allFunds.map((item: any) => {
      if (item.symbol_code === fund_code) {
        fields["nav"] = item.nav;
        fields["face_value"] = item.face_value;

        setFields(fields);

        let stock_market_data = [] as any;
        if (
          item.stock_market !== "" &&
          item.stock_market !== "[]" &&
          item.stock_market !== undefined
        ) {
          let stock_arr = JSON.parse(item.stock_market);
          stock_arr.map((item, ind) => {
            stock_market_data.push(item);
          });
          setStockMarketData(stock_market_data);
        } else {
          setStockMarketData([]);
        }
      }
    });
    setAccLoading(true);
    //get account by fund name for dropdown
    try {
      const accResponse = await getAccountByFund(email, fund_code, amc_code);
      let temp = accResponse.data.data.map((val) => {
        return {
          ...val,
          label: `${val.bank_name} ${val.branch_name} (${val.account_title})`,
          value: val.account_code,
        };
      });
      // temp.unshift({ value: 'Other', label: 'Other' });
      setToAccountData(temp);
      setAccountNoData(temp);
      if (accResponse.data.data.length < 1) {
        setAccountCheck(true);
      } else {
        setAccountCheck(false);
      }
    } catch (error) {}
    setAccLoading(false);
  };

  // Function to get aLL Accounts of selected Fund from Instruction Section
  const [counterFundLoading, setCounterFundLoading] = useState(false);

  const getChartOfAccountsFromBackend = async () => {
    try {
      setLoading(true);
      let response = await getNewChartsOfAccountsByFund(email, amc_code, fund);
      if (response.data.status === 200) {
        setChartOfAccounts(response.data.data?.main_family);
        setLoading(false);
      } else {
        toast.error("No associated chart of account!");

        setChartOfAccounts(undefined);
      }
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message?.toString());
      } else {
        toast.error(err.message || "Request Failed!");
      }
    }
  };

  React.useEffect(() => {
    if (fund) {
      getChartOfAccountsFromBackend();
    }
  }, [fund]);

  const getLedgerAccountsByChart = async () => {
    try {
      const response = await getChartOfAccounts(email);
      if (response.data.status == 200) {
        let ledgersacc = getLedgerAccounts(
          response.data.data.main_family[0].family[3].sub_family
        );
        setLegderAccounts(ledgersacc);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {}
  };

  React.useEffect(() => {
    if (chartOfAccounts && chartOfAccounts.length > 0) {
      getLedgerAccountsByChart();
    }
  }, [chartOfAccounts]);

  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }
    return txType;
  };

  const flag = sessionStorage.getItem("rejectedFlag") || false;
  const [grossAmountReadOnly, setGrossAmountReadOnly] = useState(false);
  const [netAmountReadOnly, setNetAmountReadOnly] = useState(false);
  const [unitsReadOnly, setUnitsReadOnly] = useState(false);
  const [discount_applicable_ReadOnly, setDiscount_Applicable_ReadOnly] =
    useState(false);
  const [allStateDropdown, setAllStateDropdown] = useState({
    fund_name: 0,
    from_fund_account: 0,
  });

  React.useEffect(() => {
    const getAllLegders = async () => {
      // const response = await getChartOfAccounts(email);
      // if (response.data.status === 200) {
      setAllLedgerData(getAllLedgers(chartOfAccounts));
      // }
    };

    if (chartOfAccounts) {
      getAllLegders();
    }
  }, [chartOfAccounts]);

  React.useEffect(() => {
    let periodRange = sessionStorage.getItem("active_period") || "";
    setHeadLabel(props.match.params.type);
    // fields["txnr_type"] = props.match.params.type;
    fields["period"] = periodRange;
    fields["txnr_type"] = "vouchers";

    // setFields(fields);
    counterAccounter = getCounterAccount(props.match.params.type);
    if (counterAccounter === "Other") {
      fields["counter_account_type"] = "Other";
      setFields(fields);
    }
    if (
      props.match.params.type === "debtmarketinvestment" ||
      props.match.params.type === "equityinvestment"
    ) {
      setGrossAmountReadOnly(true);
      setNetAmountReadOnly(true);
    }
  }, [props.match.params.type]);

  React.useEffect(() => {
    allLedgerData.map((item, index) => {
      if (index === 0) {
        if (item.name) {
          return setLedgerOption([
            {
              label: `${item.code} - ${item.name}`,
            },
          ]);
        } else if (item.bank) {
          return setLedgerOption([
            {
              label: `${item.code} - ${item.bank}`,
            },
          ]);
        }
      }

      if (item.name) {
        return setLedgerOption((prevState) => [
          ...prevState,
          {
            label: `${item.code} - ${item.name}`,
          },
        ]);
      } else if (item.bank) {
        return setLedgerOption((prevState) => [
          ...prevState,
          {
            label: `${item.code} - ${item.bank}`,
          },
        ]);
      }
    });
  }, [allLedgerData]);

  const loggedInUser = JSON.parse(sessionStorage.getItem("loggedInUser") || "");

  // filed Object Hook For geting data from fields / object for transaction creation
  let date = new Date();
  let periodData = sessionStorage.getItem("active_period") || "";
  let disableDates = moment(date).format("YYYY-MM-DD");
  const [fields, setFields] = useState<FieldValues>({
    email: email,
    txnr_type: "vouchers",
    amc_code: loggedInUser.amc_code,
    dividend_date: "",
    dividend_rate: "",
    fund_code: "",
    reinvest: "false",
    instruction_date: moment(date).format("YYYY-MM-DD"),
    execution_date: moment(date).format("YYYY-MM-DD"),
    executed_date: moment(date).format("YYYY-MM-DD"),
    fund_account: "",
    account_title: "",
    account_no: "",
    bank: "",
    branch: "",
    counter_account_type: "",
    counter_type: "",
    counter_account_title: "",
    counter_account_number: "",
    counter_bank: "",
    counter_branch: "",
    mode_of_payment: "",
    payment_type: "",
    instrument_no: "",
    instrument_type: "",
    instrument_date: moment(date).format("YYYY-MM-DD"),
    // realized_date: moment(date).format('YYYY-MM-DD'),
    realized_date: moment(date).format("YYYY-MM-DD"),
    realized: "true",
    gross_amount: "",
    net_amount: 0,
    dr_amount: "",
    period: periodData,
    cr_amount: "",
    balance: "",
    folio_no: "",
    unitholder_name: "",
    units: "",
    nav: "",
    sale_date: moment(date).format("YYYY-MM-DD"),
    current_holding: "0",
    total_holding: "",
    symbol: "",
    dividend_percentage: "",
    credit_date: "",
    maturity_type: "",
    security_type: "",
    issue_date: moment(date).format("YYYY-MM-DD"),
    conversion_date: moment(date).format("YYYY-MM-DD"),
    associated_transaction: "",
    maturity_date: moment(date).format("YYYY-MM-DD"),
    coupon_rate: "",
    price: "",
    face_value: "",
    money_market_face_value: "",
    detail: "",
    type: "",
    redemption_date: moment(date).format("YYYY-MM-DD"),
    remain_holding: "0",
    settlement_by: "",
    tax_type: "",
    settlement_date: moment(date).format("YYYY-MM-DD"),
    total_charges: "0",
    txn_charges: "",
    sale_txn_no: "",
    return_date: "",
    txn_id: "",
    last_coupon_date: moment(date).format("YYYY-MM-DD"),
    next_coupon_date: moment(date).format("YYYY-MM-DD"),
    yield: "",
    tenor: "",
    fund_ips_account: "",
    counter_party_ips_account: "",
    system_tax: "",
    primary_dealer: "",
    broker_commission: "",
    tax_sst: "",
    tax_wht_it: "",
    tax_wht_sst: "",
    tax_cgt: "0",
    sale_load: "",
    redemption_load: "0",
    low_balance_agree: "",
    offer_price: "",
    load_per_unit: "",
    percentage_of_discount: "0",
    applicable_offer_price: "",
    sales_tax_collector: "SRB", // default value SRB
    volume: "",
    par_value: "",
    announcement_date: "", // Dividend on Investment
    bonus_percentage: "",
    bonus_credit_date: "",
    bonus_gross_volume: "",
    tax_it_bonus_amount: "",
    net_bonus_volume: "",
    right_share_percentage: "",
    right_share_credit_date: "",
    right_share_gross_volume: "",
    tax_it_right_share_amount: "",
    net_right_share_volume: "",
    tax_on_dvidend: "",
    tax_on_bonus: "",
    tax_on_right: "",
    zakat_amount: "0",
    ledgers: "",
  });

  //code for edit transaction
  let [count, setCount] = useState(0);

  React.useEffect(() => {
    if (flag) {
      const obj = JSON.parse(sessionStorage.getItem("rejectedTxObj") || " ");
      getFundByAMcCode(obj.amc_code);
      fields["payment_type"] = obj.payment_type || "";
      fields["txnr_type"] = obj.txnr_type || "vouchers";
      fields["amc_code"] = obj.amc_code || "";
      getAccountByFundName(obj.fund_code);
      fields["fund_code"] = obj.fund_code || "";
      getBranchByName(obj.bank);
      getCounterBranchByName(obj.counter_bank);
      fields["instruction_date"] = obj.instruction_date || "";
      fields["execution_date"] = obj.execution_date || "";
      fields["executed_date"] = obj.executed_date || "";
      fields["fund_account"] = obj.fund_account || "";
      fields["dividend_date"] = obj.dividend_date || "";
      fields["dividend_rate"] = obj.dividend_rate || "";
      fields["reinvest"] = obj.reinvest || "";
      fields["period"] =
        sessionStorage.getItem("active_period") || obj.period || "";
      fields["account_title"] = obj.account_title || "";
      fields["account_no"] = obj.account_number || "";
      fields["bank"] = obj.bank || "";
      fields["branch"] = obj.branch || "";
      fields["counter_account_type"] = obj.counter_account_type || "";
      fields["counter_type"] = obj.counter_type || "";
      fields["counter_account_title"] = obj.counter_account_title || "";
      fields["counter_account_number"] = obj.counter_account_number || "";
      fields["counter_bank"] = obj.counter_bank || "";
      fields["counter_branch"] = obj.counter_branch || "";
      fields["mode_of_payment"] = obj.mode_of_payment || "";
      fields["instrument_no"] = obj.instrument_no || "";
      fields["instrument_type"] = obj.instrument_type || "";
      fields["instrument_date"] = obj.instrument_date || "";
      fields["realized_date"] = obj.realized_date || "";
      fields["realized"] = obj.realized || "";
      fields["gross_amount"] = obj.gross_amount.toString() || "";
      fields["net_amount"] = obj.net_amount.toString() || "";
      fields["dr_amount"] = "0";
      fields["cr_amount"] = "0";
      fields["balance"] = obj.balance.toString() || "";
      fields["folio_no"] = obj.folio_no || "";
      fields["unitholder_name"] = obj.unitholder_name || "";
      fields["units"] = obj.units.toString() || "";
      fields["nav"] = obj.nav.toString() || "";
      fields["sale_date"] = obj.sale_date || "";
      fields["current_holding"] = obj.current_holding.toString() || "";
      fields["total_holding"] = obj.total_holding.toString() || "";
      fields["symbol"] = obj.symbol || "";
      fields["dividend_percentage"] = obj.dividend_percentage.toString() || "";
      fields["credit_date"] = obj.credit_date || "";
      fields["maturity_type"] = obj.maturity_type || "";
      fields["security_type"] = obj.security_type || "";
      fields["issue_date"] = obj.issue_date || "";
      fields["conversion_date"] = obj.conversion_date || "";
      fields["associated_transaction"] = obj.associated_transaction || "";
      fields["maturity_date"] = obj.maturity_date || "";
      fields["coupon_rate"] = obj.coupon_rate || "";
      fields["price"] = obj.price.toString() || "";
      fields["face_value"] = obj.face_value.toString() || "";
      fields["money_market_face_value"] =
        obj.money_market_face_value.toString() || "";
      fields["detail"] = obj.detail || "";
      fields["type"] = obj.type || "";

      fields["redemption_date"] = obj.redemption_date || "";
      fields["remain_holding"] = obj.remain_holding.toString() || "";
      fields["settlement_by"] = obj.settlement_by || "";
      fields["tax_type"] = obj.tax_type || "";
      fields["settlement_date"] = obj.settlement_date || "";
      fields["total_charges"] = obj.total_charges.toString() || "";
      fields["sale_txn_no"] = obj.sale_txn_no || "";
      fields["return_date"] = obj.return_date || "";
      fields["trx_id"] = obj.txn_id || "";
      fields["primary_dealer"] = obj.primary_dealer;
      fields["yield"] = obj.yield || "";

      if (headLabel === "" || headLabel === "") {
        fields["sale_load"] = obj.sale_load || "";
      }

      if (headLabel === "" || headLabel === "") {
        fields["redemption_load"] = obj.redemption_load || "";
        fields["tax_cgt"] = obj.tax_cgt || "";
      }

      fields["zakat_amount"] = obj.zakat_amount;
      fields["txn_status"] = "CREATED";
      // Dividend On Investment
      fields["volume"] = obj.volume;
      fields["par_value"] = obj.par_value;
      fields["announcement_date "] = obj.announcement_date;
      fields["bonus_percentage"] = obj.bonus_percentage;
      fields["bonus_credit_date"] = obj.bonus_credit_date;
      fields["bonus_gross_volume"] = obj.bonus_gross_volume;
      fields["tax_it_bonus_amount"] = obj.tax_it_bonus_amount;
      fields["net_bonus_volume"] = obj.net_bonus_volume;
      fields["right_share_percentage"] = obj.right_share_percentage;
      fields["right_share_credit_date"] = obj.right_share_credit_date;
      fields["right_share_gross_volume"] = obj.right_share_gross_volume;
      fields["tax_it_right_share_amount"] = obj.tax_it_right_share_amount;
      fields["net_right_share_volume"] = obj.net_right_share_volume;
      fields["tax_on_dvidend"] = obj.tax_on_dvidend;
      fields["tax_on_bonus"] = obj.tax_on_bonus;
      fields["tax_on_right"] = obj.tax_on_right;
      count = count + 1;
      setCount(count);
      fields["fund_ips_account"] = obj.fund_ips_account || "";
      fields["counter_party_ips_account"] = obj.counter_party_ips_account || "";
      fields["low_balance_agree"] = "";
      fields["period"] = sessionStorage.getItem("active_period") || "";
    }
  }, []);

  const [bankNameData, setBankNameData] = useState<any>([]);
  const [amcdataCounter, setAmcdataCounter] = useState<any>([]); // all Amc Data

  //end
  React.useEffect(() => {
    setFlowLoading(true);
    const fetchAmc = async () => {
      MOPData.length = 0;
      setMOPData(MOPData);

      // get funds by amc_code
      try {
        const loggedInUser = JSON.parse(
          sessionStorage.getItem("loggedInUser") || ""
        );
        await getFundByAMcCode(loggedInUser.amc_code);
      } catch (error) {}

      // get all transaction ledgers
      try {
        const response = await getTransactionsLedgers(email);
        if (response.data.status == 200) {
          let unitManagement =
            response.data.data.txn_catagory[0].unitManagementTxn;
          let txnLegders = await getLedgersByTxn(
            unitManagement,
            props.match.params.type
          );

          setTransactionLedgers(txnLegders);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {}

      try {
        const response = await searchAPI(email, loggedInUser.amc_code);
        let temp = response.data.data.map((val) => {
          return {
            ...val,
            label: `${val.account_no}`,
            value: val.account_no,
          };
        });
        temp.unshift({
          value: "Other",
          label: "Other",
        });
        setAmcdataCounter(temp);
      } catch (err: any) {
        if (err.response !== undefined) {
          toast.error(err.response.data.message);
        }
      }

      //api call to fetch data for bank dropdown
      try {
        const bankResponse = await getAllBanks(email, "", "", amc_code);
        let temp = bankResponse.data.data.map((val) => {
          return {
            ...val,
            label: `${val.bank_code.replace("BANK_", "")} (${val.bank_name})`,
            value: val.bank_code.replace("BANK_", ""),
          };
        });
        temp.unshift({ value: "Other", label: "Other" });
        setBankNameData(temp);
      } catch (error) {}
      //get all getModeOfPayments list for dropdown
      try {
        const response = await getModeOfPayments(email);
        setMOPData(response.data.mode_of_payment);
      } catch (error) {}
      //get InstrumentType data
      try {
        const inTypeResponse = await getInstrumentType(email);
        setITypeData(inTypeResponse.data.instrument_types);
      } catch (error) {}

      try {
        const brokerResponse = await getBrokerByType(
          email,
          counterAccounter,
          amc_code
        );
        let temp = brokerResponse.data.data.map((val) => {
          return {
            ...val,
            label: `${val.company_name} (${val.company_code})`,
            value: val.company_code,
          };
        });
        temp.unshift({ value: "Other", label: "Other" });

        setBorkerByTypeData(temp);
        brokerResponse.data.data.length > 0
          ? setBrokerCountFlag(false)
          : setBrokerCountFlag(true);
      } catch (error) {}

      setFlowLoading(false);
    };
    fetchAmc();
  }, []);

  //render dropdown for tax data

  const renderModeOfPayments = () => {
    return MOPData.map((item: any, index: string) => {
      return {
        value: item,
        label: item,
      };
    });
  };

  //Debit Ledger Funds DropDown selection

  const renderFundsDropdown = () => {
    return allFunds.map((item: any, index: string) => {
      if (item.nature === "Special Managed Account") {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code}) - SMA`,
        };
      } else {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code})`,
        };
      }
    });
  };

  //add debit modal

  //modal for add debit entry
  const [viewAddDebitModal, setViewAddDebitModal] = useState(false);
  const renderModalForAddDebit = () => {
    if (viewAddDebitModal) {
      return (
        <Modal
          className=""
          dialogClassname="debitModal"
          show={true}
          // size="xl"
          backdrop={true}
          onHide={() => {
            setViewAddDebitModal(false);
            setInputValueSelectedLedgerDebit("");
            setValueSelectedLedgerDebit("");
            setSelectedLedgerDebit("");
            setEditDebitIndex(-1);
            setAmountDebit("0");
            setDescriptionDebit("");
            setInvoiceNumberDebit("");
          }}
        >
          <div className="modal-header">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setViewAddDebitModal(false);
                setInputValueSelectedLedgerDebit("");
                setValueSelectedLedgerDebit("");
                setSelectedLedgerDebit("");
                setEditDebitIndex(-1);
                setAmountDebit("0");
                setDescriptionDebit("");
                setInvoiceNumberDebit("");
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">
              {editDebitIndex > -1 ? "Update " : "Add "} Debit Record
            </h6>
          </div>

          <div className="modal-body">
            <Row>
              <Col>
                <div className="form-group " data-tip="Select Ledger">
                  {ledgerOption.length > 1 ? (
                    <Autocomplete
                      className="mt-2 autocomplete"
                      disablePortal
                      id="combo-box-demo"
                      options={ledgerOption}
                      style={{ width: "100%" }}
                      noOptionsText={
                        <div
                          style={{
                            color:
                              theme === "light"
                                ? "black"
                                : "rgba(255, 255, 255, 0.5)",
                          }}
                        >
                          No options
                        </div>
                      }
                      PaperComponent={({ children }) => (
                        <Paper
                          style={{
                            background: theme == "light" ? "" : "#1E1E2F",
                            color: "white",
                            position: "absolute",
                            width: "101%",
                            left: "-3px",
                          }}
                        >
                          {children}
                        </Paper>
                      )}
                      value={valueSelectedLedgerDebit}
                      onChange={(event: any, newValue: string | null) => {
                        setValueSelectedLedgerDebit(newValue);
                      }}
                      inputValue={inputValueSelectedLedgerDebit}
                      onInputChange={(event, newInputValue) => {
                        setInputValueSelectedLedgerDebit(newInputValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Ledger*"
                          variant="standard"
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-input": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },
                        "& .MuiInputLabel-root": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },

                        "& .MuiIconButton-root": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },
                      }}
                    />
                  ) : (
                    <div className="form-control w-100">
                      <i className="fa fa-spinner fa-spin fa-1x"></i>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <div>Amount</div>
                  <NumberFormat
                    decimalScale={4}
                    thousandSeparator={true}
                    inputMode="numeric"
                    style={{ textAlign: "right" }}
                    value={parseFloat(amountDebit)}
                    className={"form-control w-100 " + ErrorBorder(amountDebit)}
                    onChange={(e) => {
                      setAmountDebit(e.target.value?.replaceAll(",", ""));
                    }}
                  />
                </div>
                <div className="form-group">
                  <div>Description</div>
                  <input
                    type="text"
                    placeholder="Describe the debit transaction"
                    value={descriptionDebit}
                    className={
                      "form-control w-100" + ErrorBorder(descriptionDebit)
                    }
                    onChange={(e) => {
                      setDescriptionDebit(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <div>Invoice Number</div>
                  <input
                    type="text"
                    placeholder="Invoice Number"
                    value={invoiceNumberDebit}
                    className={
                      "form-control w-100" + ErrorBorder(invoiceNumberDebit)
                    }
                    onChange={(e) => {
                      setInvoiceNumberDebit(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group d-flex justify-content-between">
                  <div className="hidden"></div>
                  <div
                    className="btn"
                    onClick={() => {
                      if (inputValueSelectedLedgerDebit === "") {
                        toast.error("Ledger selection is must!");
                      } else if (parseInt(amountDebit) === 0) {
                        toast.error("Amount should not be 0");
                      } else if (amountDebit === "") {
                        toast.error("Amount should not be empty");
                      } else {
                        if (editDebitIndex > -1) {
                          setDebitFormData([
                            ...debitFormData.slice(0, editDebitIndex),
                            {
                              ledger: inputValueSelectedLedgerDebit,
                              amount: amountDebit,
                              description: descriptionDebit,
                              invoiceNumber: invoiceNumberDebit,
                            },
                            ...debitFormData.slice(editDebitIndex + 1),
                          ]);

                          toast.success("Debit updated successfully!");
                        } else {
                          setDebitFormData((prevState) => [
                            ...prevState,
                            {
                              ledger: inputValueSelectedLedgerDebit,
                              amount: amountDebit,
                              description: descriptionDebit,
                              invoiceNumber: invoiceNumberDebit,
                            },
                          ]);
                          toast.success("Debit added successfully!");
                        }

                        setInputValueSelectedLedgerDebit("");
                        setValueSelectedLedgerDebit("");
                        setSelectedLedgerDebit("");
                        setAmountDebit("0");
                        setDescriptionDebit("");
                        setInvoiceNumberDebit("");
                        setEditDebitIndex(-1);
                        setViewAddDebitModal(false);
                      }
                    }}
                  >
                    {editDebitIndex > -1 ? "Update" : "Add"}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Modal>
      );
    }
  };

  //view debit modal
  const [viewViewDebitModal, setViewViewDebitModal] = useState(false);
  const renderModalForViewDebit = (index) => {
    if (viewViewDebitModal === true) {
      let viewValue = { ...debitFormData[index] };

      return (
        <Modal
          className=""
          dialogClassname="debitModal"
          show={true}
          // size="xl"
          backdrop={true}
          onHide={() => {
            setViewViewDebitModal(false);
          }}
        >
          <div className="modal-header">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setViewViewDebitModal(false);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">Debit Record</h6>
          </div>

          <div className="modal-body">
            <Row>
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className="form-group " data-tip="Select Ledger">
                  {ledgerOption.length > 1 ? (
                    <Autocomplete
                      className="mt-2  autocomplete"
                      disablePortal
                      id="combo-box-demo"
                      options={ledgerOption}
                      style={{ width: 300 }}
                      noOptionsText={
                        <div
                          style={{
                            color:
                              theme === "light"
                                ? "black"
                                : "rgba(255, 255, 255, 0.5)",
                          }}
                        >
                          No options
                        </div>
                      }
                      PaperComponent={({ children }) => (
                        <Paper
                          style={{
                            background: theme == "light" ? "" : "#1E1E2F",
                            color: "white",
                            position: "absolute",
                            width: "101%",
                            left: "-3px",
                          }}
                        >
                          {children}
                        </Paper>
                      )}
                      value={viewValue.ledger}
                      disabled
                      onChange={(event: any, newValue: string | null) => {
                        viewValue.ledger(newValue);
                      }}
                      inputValue={viewValue.ledger}
                      onInputChange={(event, newInputValue) => {
                        viewValue.ledger(newInputValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Ledger*"
                          variant="standard"
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-input": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },
                        "& .MuiInputLabel-root": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },

                        "& .MuiIconButton-root": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },
                      }}
                    />
                  ) : (
                    <i className="mt-2 fa fa-spinner fa-spin fa-1x"></i>
                  )}
                </div>
                <div className="form-group">
                  <div>Amount</div>
                  <input
                    type="text"
                    value={parseFloat(viewValue.amount || "0")?.toFixed(4)}
                    className={
                      "form-control w-100 " + ErrorBorder(amountCredit)
                    }
                    disabled
                  />
                </div>
                <div className="form-group">
                  <div>Description</div>
                  <input
                    type="text"
                    placeholder="Describe the credit transaction"
                    value={viewValue.description}
                    className={
                      "form-control w-100" + ErrorBorder(descriptionCredit)
                    }
                    disabled
                  />
                </div>
                <div className="form-group">
                  <div>Invoice Number</div>
                  <input
                    type="text"
                    placeholder="Invoice Number"
                    value={viewValue.invoiceNumber}
                    className={"form-control w-100"}
                    disabled
                  />
                </div>
                <div className="form-group d-flex justify-content-between">
                  <div className="hidden"></div>
                  <div
                    className="btn"
                    onClick={() => {
                      setViewViewDebitModal(false);
                    }}
                  >
                    Close
                  </div>
                </div>
              </div>
              <div className="col-md-2"></div>
            </Row>
          </div>
        </Modal>
      );
    }
  };

  //handle Debit Delete
  //delete credit
  const handleDebitDelete = (ledger, amount, index) => {
    if (debitFormData.length > 0) {
      setDebitFormData(debitFormData.filter((data, ind) => ind !== index));
    }
    toast.success("Debit record deleted!");
  };

  //Add Credit Modal
  const [viewAddCreditModal, setViewAddCreditModal] = useState(false);
  const renderModalForAddCredit = () => {
    if (viewAddCreditModal) {
      return (
        <Modal
          className=""
          dialogClassname="creditModal"
          show={true}
          // size="xl"
          backdrop={true}
          onHide={() => {
            setViewAddCreditModal(false);
            setInputValueSelectedLedgerCredit("");
            setValueSelectedLedgerCredit("");
            setAmountCredit("0");
            setDescriptionCredit("");
            setInvoiceNumberCredit("");
            setEditCreditIndex(-1);
          }}
        >
          <div className="modal-header">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setViewAddCreditModal(false);
                setInputValueSelectedLedgerCredit("");
                setValueSelectedLedgerCredit("");
                setAmountCredit("0");
                setDescriptionCredit("");
                setInvoiceNumberCredit("");
                setEditCreditIndex(-1);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">
              {editCreditIndex > -1 ? "Update " : "Add "} Credit Record
            </h6>
          </div>

          <div className="modal-body">
            <Row>
              <Col>
                <div className="form-group " data-tip="Select Ledger">
                  {ledgerOption.length > 1 ? (
                    <Autocomplete
                      className="mt-2 autocomplete w-100"
                      disablePortal
                      id="combo-box-demo"
                      options={ledgerOption}
                      style={{ width: 300 }}
                      noOptionsText={
                        <div
                          style={{
                            color:
                              theme === "light"
                                ? "black"
                                : "rgba(255, 255, 255, 0.5)",
                          }}
                        >
                          No options
                        </div>
                      }
                      PaperComponent={({ children }) => (
                        <Paper
                          style={{
                            background: theme == "light" ? "" : "#1E1E2F",
                            color: "rgba(255, 255, 255, 0.5) !important",
                            position: "absolute",
                            width: "101%",
                            left: "-3px",
                          }}
                        >
                          {children}
                        </Paper>
                      )}
                      value={valueSelectedLedgerCredit}
                      onChange={(event: any, newValue: string | null) => {
                        setValueSelectedLedgerCredit(newValue);
                      }}
                      inputValue={inputValueSelectedLedgerCredit}
                      onInputChange={(event, newInputValue) => {
                        setInputValueSelectedLedgerCredit(newInputValue);
                      }}
                      sx={{
                        "& .MuiAutocomplete-input": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },
                        "& .MuiInputLabel-root": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },

                        "& .MuiIconButton-root": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Ledger*"
                          variant="standard"
                        />
                      )}
                    />
                  ) : (
                    <div className="form-control w-100">
                      <i className="fa fa-spinner fa-spin fa-1x"></i>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <div>Amount</div>
                  <NumberFormat
                    decimalScale={4}
                    thousandSeparator={true}
                    inputMode="numeric"
                    style={{ textAlign: "right" }}
                    value={parseFloat(amountCredit || "0")?.toFixed(4)}
                    className={
                      "form-control w-100 " + ErrorBorder(amountCredit)
                    }
                    onChange={(e) => {
                      setAmountCredit(e.target.value?.replaceAll(",", ""));
                    }}
                  />
                </div>
                <div className="form-group">
                  <div>Description</div>
                  <input
                    type="text"
                    placeholder="Describe the credit transaction"
                    value={descriptionCredit}
                    className={
                      "form-control w-100" + ErrorBorder(descriptionCredit)
                    }
                    onChange={(e) => {
                      setDescriptionCredit(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <div>Invoice Number</div>
                  <input
                    type="text"
                    placeholder="Invoice Number"
                    value={invoiceNumberCredit}
                    className={
                      "form-control w-100" + ErrorBorder(invoiceNumberCredit)
                    }
                    onChange={(e) => {
                      setInvoiceNumberCredit(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group d-flex justify-content-between">
                  <div className="hidden"></div>
                  <div
                    className="btn"
                    onClick={() => {
                      if (inputValueSelectedLedgerCredit === "") {
                        toast.error("Ledger selection is must!");
                      } else if (parseInt(amountCredit) === 0) {
                        toast.error("Amount should not be 0");
                      } else if (amountCredit === "") {
                        toast.error("Amount should not be empty");
                      } else {
                        if (editCreditIndex > -1) {
                          setCreditFormData([
                            ...creditFormData.slice(0, editCreditIndex),
                            {
                              ledger: inputValueSelectedLedgerCredit,
                              amount: amountCredit,
                              description: descriptionCredit,
                              invoiceNumber: invoiceNumberCredit,
                            },
                            ...creditFormData.slice(editCreditIndex + 1),
                          ]);

                          toast.success("Credit record updated!");
                        } else {
                          setCreditFormData((prevState) => [
                            ...prevState,
                            {
                              ledger: inputValueSelectedLedgerCredit,
                              amount: amountCredit,
                              description: descriptionCredit,
                              invoiceNumber: invoiceNumberCredit,
                            },
                          ]);

                          toast.success("Credit record added!");
                        }
                        setInputValueSelectedLedgerCredit("");
                        setValueSelectedLedgerCredit("");
                        setAmountCredit("0");
                        setDescriptionCredit("");
                        setInvoiceNumberCredit("");
                        setEditCreditIndex(-1);
                        setViewAddCreditModal(false);
                      }
                    }}
                  >
                    {editCreditIndex > -1 ? "Update" : "Add"}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Modal>
      );
    }
  };

  //view credit modal
  const [viewViewCreditModal, setViewViewCreditModal] = useState(false);
  const renderModalForViewCredit = (index) => {
    if (viewViewCreditModal === true) {
      let viewValue = { ...creditFormData[index] };

      return (
        <Modal
          className=""
          dialogClassname="creditModal"
          show={true}
          // size="xl"
          backdrop={true}
          onHide={() => {
            setViewViewCreditModal(false);
          }}
        >
          <div className="modal-header">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setViewViewCreditModal(false);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">Credit Record</h6>
          </div>

          <div className="modal-body">
            <Row>
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className="form-group " data-tip="Select Ledger">
                  {ledgerOption.length > 1 ? (
                    <Autocomplete
                      className="mt-2 autocomplete"
                      disablePortal
                      id="combo-box-demo"
                      options={ledgerOption}
                      style={{ width: 300 }}
                      noOptionsText={
                        <div
                          style={{
                            color:
                              theme === "light"
                                ? "black"
                                : "rgba(255, 255, 255, 0.5)",
                          }}
                        >
                          No options
                        </div>
                      }
                      PaperComponent={({ children }) => (
                        <Paper
                          style={{
                            background: theme == "light" ? "" : "#1E1E2F",
                            color: "white",
                            position: "absolute",
                            width: "101%",
                            left: "-3px",
                          }}
                        >
                          {children}
                        </Paper>
                      )}
                      sx={{
                        "& .MuiAutocomplete-input": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },
                        "& .MuiInputLabel-root": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },

                        "& .MuiIconButton-root": {
                          color:
                            theme == "light"
                              ? "black !important"
                              : "rgba(255, 255, 255, 0.5) !important",
                        },
                      }}
                      value={viewValue.ledger}
                      disabled
                      onChange={(event: any, newValue: string | null) => {
                        viewValue.ledger(newValue);
                      }}
                      inputValue={viewValue.ledger}
                      onInputChange={(event, newInputValue) => {
                        viewValue.ledger(newInputValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Ledger*"
                          variant="standard"
                        />
                      )}
                    />
                  ) : (
                    <div className="form-control w-100">
                      <i className="fa fa-spinner fa-spin fa-1x"></i>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <div>Amount</div>
                  <input
                    type="text"
                    value={parseFloat(viewValue.amount || "0")?.toFixed(4)}
                    className={
                      "form-control w-100 " + ErrorBorder(amountCredit)
                    }
                    disabled
                  />
                </div>
                <div className="form-group">
                  <div>Description</div>
                  <input
                    type="text"
                    placeholder="Describe the credit transaction"
                    value={viewValue.description}
                    className={
                      "form-control w-100" + ErrorBorder(descriptionCredit)
                    }
                    disabled
                  />
                </div>
                <div className="form-group">
                  <div>Invoice Number</div>
                  <input
                    type="text"
                    placeholder="Invoice Number"
                    value={viewValue.invoiceNumber}
                    className={"form-control w-100"}
                    disabled
                  />
                </div>
                <div className="form-group d-flex justify-content-between">
                  <div className="hidden"></div>
                  <div
                    className="btn"
                    onClick={() => {
                      setViewViewCreditModal(false);
                    }}
                  >
                    Close
                  </div>
                </div>
              </div>
              <div className="col-md-2"></div>
            </Row>
          </div>
        </Modal>
      );
    }
  };

  //delete credit
  const handleCreditDelete = (ledger, amount, index) => {
    if (creditFormData.length > 0) {
      setCreditFormData(creditFormData.filter((data, ind) => ind !== index));
    }
    toast.success("Credit record deleted!");
  };

  const renderiTypeDataDropdown = () => {
    return iTypeData.map((item: any, index: string) => {
      return {
        value: item,
        label: item,
      };
    });
  };
  // filter securities data based on security_type selection

  const [allbranchesData, setAllBranchesData] = useState<any>([]);
  const [branchCheckFlag, setBranchCheckFlag] = useState(false);
  const [allCounterbranchesData, setAllCounterBranchesData] = useState<any>([]);

  const getBranchByName = async (name: string) => {
    //get all branches for selected bank for dropdown
    try {
      const response = await getBranchByBankName(email, name, amc_code);
      let temp = response.data.data.map((val) => {
        return {
          ...val,
          label: `${val.branch_name}`,
          value: val.branch_name,
        };
      });
      temp.unshift({ value: "Other", label: "Other" });
      setAllBranchesData(temp);
      if (response.data.data.length > 0) {
        setBranchCheckFlag(false);
      } else {
        setBranchCheckFlag(true);
      }
    } catch (error) {}
  };

  const getCounterBranchByName = async (name: string) => {
    //get all branches for selected bank for dropdown
    try {
      const response = await getBranchByBankName(email, name, amc_code);
      let temp = response.data.data.map((val) => {
        return {
          ...val,
          label: `${val.branch_name}`,
          value: val.branch_name,
        };
      });
      temp.unshift({ value: "Other", label: "Other" });
      setAllCounterBranchesData(temp);
      if (response.data.data.length > 0) {
        setBranchCheckFlag(false);
      } else {
        setBranchCheckFlag(true);
      }
    } catch (error) {}
  };

  //for Validation
  const validate = async () => {
    let count = 0;
    requiredFields.map((item, index) => {
      if (flag) {
        const value = fields[item];
        if (value === "") {
          count = count + 1;
        }
      } else {
        const value = fields[item];
        if (value === "") {
          count = count + 1;
        }
      }
    });
    if (count > 0) {
      return false;
    } else {
      return true;
    }
  };

  //Create Transaction Api Call
  //Ahsan Create Transaction Code
  const createTransaction = async () => {
    if (!chechFieldDisplay(headLabel, "nav")) {
      fields["nav"] = "";
    }

    fields["counter_type"] =
      counterType !== "" ? counterType : counterAccounter;

    const isValid = await validate(); // check validation for Fields Data
    if (isValid) {
      setLoading(true);
      if (
        parseFloat(fields["net_amount"]) < 0 ||
        parseFloat(fields["gross_amount"]) < 0 ||
        parseFloat(fields["units"]) < 0 ||
        parseFloat(fields["remain_holding"]) < 0
      ) {
        toast.error("Amounts or units or remaining holding are negative");
      } else {
        if (+balance != 0) {
          toast.error(
            `Balance should be 0, Other wise you can't create transaction`
          );
          return;
        }

        try {
          const navCheck = await validateFundNav(
            email,
            amc_code,
            fields?.fund_code,
            fields?.settlement_date
          );

          if (navCheck?.status === 200 && navCheck?.data?.status !== 200) {
            toast.error(navCheck?.data?.message);
            setLoading(false);
            return;
          }

          fields.face_value = fields?.face_value
            ? fields?.face_value.toString()
            : "0";
          const response = await addMegaTransaction(fields); // for add new transaction
          if (response.data.status === 400) {
            setViewBankBalanceModal(true);
            toast.warning(response.data.message);
          } else if (response.data.status === 417) {
            toast.warning(response.data.message);
          } else {
            setUnderStand(false);
            setViewBankBalanceModal(false);
            sessionStorage.setItem("last_id", response.data.txn_id);
            toast.success(`${response.data.message} - ${response.data.txn_id}`);

            setTimeout(() => {
              history.goBack();
            }, 3000);
          }
        } catch (error: any) {
          setLoading(false);
          if (error.response !== undefined) {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong!");
          }
        }
      }
    } else {
      setLoading(false);
      setErrorShow(true);
      toast.error("Kindly Fill All the Fields");
    }
  };

  //Creating Ledgers for credit/debit
  const handleCreate = async () => {
    setLoading(true);
    if (debitFormData.length === 0) {
      setLoading(false);
      return toast.error("Debit data can't be empty!");
    }
    if (creditFormData.length === 0) {
      setLoading(false);
      return toast.error("Credit data can't be empty!");
    }
    if (fields["fund_code"].length === 0) {
      setLoading(false);
      setFundCodeError(true);
      return toast.error("Fund can't be empty!");
    }
    if (fields["instruction_date"].length === 0) {
      setLoading(false);
      setInstructionDateError(true);
      return toast.error("Instruction Date can't be empty!");
    }
    if (fields["settlement_date"].length === 0) {
      setLoading(false);
      setSettelementDateError(true);
      return toast.error("Instruction Date can't be empty!");
    }
    if (fields["mode_of_payment"].length === 0) {
      setLoading(false);
      setModeOfPaymentError(true);
      return toast.error("Mode of payment can't be empty!");
    }
    if (fields["instrument_type"].length === 0) {
      setLoading(false);
      setInstrumentTypeError(true);
      return toast.error("Select instrument type");
    } else {
      const navCheck = await validateFundNav(
        email,
        amc_code,
        fields?.fund_code,
        fields?.settlement_date
      );

      if (navCheck?.status === 200 && navCheck?.data?.status !== 200) {
        toast.error(navCheck?.data?.message);
        setLoading(false);
        return;
      }

      let sendingLedgers: any = [];

      for (let i = 0; i < debitFormData.length; i++) {
        let item = debitFormData[i];

        let ledger_code = item.ledger.split("-")[0].replace(/\s+/g, "");
        let ledgerEntitiesDebit = await getLedgerInfo(email, ledger_code, fund);
        let debitObject = {
          account_number: "",
          account_title: "",
          amc_code: amc_code,
          balance: "",
          bank_code: "",
          branch: "",
          child_family_code: ledgerEntitiesDebit.child_family_code,
          child_family_name: ledgerEntitiesDebit.child_family_name,
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          created_at: "",
          credit_amount: "0",
          debit_amount: item.amount,
          description: `JV-${item.description}`,
          doc_type: "",
          entered_by: "",
          evidence: "",
          family_code: ledgerEntitiesDebit.family_code,
          family_name: ledgerEntitiesDebit.family_name,
          fund_code: fields["fund_code"],
          gl_code: ledgerEntitiesDebit.gl_code,
          gl_name: ledgerEntitiesDebit.gl_name,
          instruction_date: fields["instruction_date"],
          instrument_by: "",
          instrument_date: fields["instrument_date"],
          instrument_no: fields["instrument_no"],
          instrument_type: fields["instrument_type"],
          main_family_code: ledgerEntitiesDebit.main_family_code,
          main_family_name: ledgerEntitiesDebit.main_family_name,
          realized: "true",
          realized_by: "",
          realized_date: "",
          sub_family_code: ledgerEntitiesDebit.sub_family_code,
          sub_family_name: ledgerEntitiesDebit.sub_family_name,
          period: sessionStorage.getItem("active_period") || "",
          paid: false,
        };

        fields["net_amount"] = (
          parseFloat(fields.net_amount) + parseFloat(item.amount)
        ).toFixed(4);

        sendingLedgers.push(debitObject);
      }

      for (let i = 0; i < creditFormData.length; i++) {
        let item = creditFormData[i];
        let ledger_code = item.ledger.split("-")[0].replace(/\s+/g, "");
        let ledgerEntitiesCredit = await getLedgerInfo(
          email,
          ledger_code,
          fund
        );
        let creditObject = {
          account_number: "",
          account_title: "",
          amc_code: amc_code,
          balance: "",
          bank_code: "",
          branch: "",
          child_family_code: ledgerEntitiesCredit.child_family_code,
          child_family_name: ledgerEntitiesCredit.child_family_name,
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          created_at: "",
          credit_amount: item.amount,
          debit_amount: "0",
          description: `JV-${item.description}`,
          doc_type: "",
          entered_by: "",
          evidence: "",
          family_code: ledgerEntitiesCredit.family_code,
          family_name: ledgerEntitiesCredit.family_name,
          fund_code: fields["fund_code"],
          gl_code: ledgerEntitiesCredit.gl_code,
          gl_name: ledgerEntitiesCredit.gl_name,
          instruction_date: fields["instruction_date"],
          instrument_by: "",
          instrument_date: fields["instrument_date"],
          instrument_no: fields["instrument_no"],
          instrument_type: fields["instrument_type"],
          main_family_code: ledgerEntitiesCredit.main_family_code,
          main_family_name: ledgerEntitiesCredit.main_family_name,
          realized: "true",
          realized_by: "",
          realized_date: "",
          sub_family_code: ledgerEntitiesCredit.sub_family_code,
          sub_family_name: ledgerEntitiesCredit.sub_family_name,
          period: sessionStorage.getItem("active_period") || "",
          paid: false,
        };
        sendingLedgers.push(creditObject);
      }

      fields.ledgers = JSON.stringify(sendingLedgers);
      fields.net_amount = fields.net_amount.toString();
      if (fields.ledgers.length > 1) {
        try {
          fields.face_value = fields?.face_value
            ? fields?.face_value.toString()
            : "0";
          const response = await addMegaTransaction(fields); // 'for add new transaction

          if (response.data.status === 400) {
            setLoading(false);
            toast.warning(response.data.message);
            // setSendingLedgers([]);
          } else if (response.data.status === 417) {
            setLoading(false);
            toast.warning(response.data.message);
            // setSendingLedgers([]);
          } else {
            toast.success(`Data added. ID: ${response.data.txn_id}`);
            // setSendingLedgers([]);

            setTimeout(() => {
              history.goBack();
            }, 1000);
          }
        } catch (error: any) {
          setLoading(false);
          // setSendingLedgers([]);
        }
      } else {
        setLoading(false);
        toast.error("Ledgers Empty");
      }
      // }
    }
  };

  const getLedgerInfo = async (email, ledger_code, fund_code) => {
    const result = await getLedgerInfoByCode(email, ledger_code, fund_code);
    return result.data.data;
  };

  const [accTilteName, setAccTiltleName] = useState("");
  const [bankBalance, setBankBalance] = useState("");

  const clearFundAccountFields = () => {
    setAccTiltleName("Unset");
    fields["fund_account"] = "";
    fields["account_title"] = "";
    fields["account_no"] = "";
    fields["bank"] = "";
    fields["branch"] = "";
    fields["nav"] = "";
    setFields(fields);
  };

  //clear fund account fileds if fund or amc is changed beacause these properties are depend on Funds
  const clearCounterAccountFields = () => {
    setAccTiltleName(fields["current_holding"] + "change");
    fields["counter_account_type"] = "";
    fields["counter_account_title"] = "";
    fields["counter_account_number"] = "";
    fields["counter_bank"] = "";
    fields["counter_branch"] = "";
    fields["current_holding"] = "";
    fields["folio_no"] = "";
    setFields(fields);
  };

  //Select data if Counter Account is Fund account
  const setFundData = (selected) => {
    counterFundAccount.map((item, index) => {
      if (item.account_no === selected) {
        setAccTiltleName(item.bank_name + "changes");
        fields["counter_account_type"] = item.account_no;
        fields["counter_account_title"] = item.account_title;
        fields["counter_account_number"] = item.account_no;
        fields["counter_bank"] = item.bank_name;
        fields["counter_branch"] = item.branch_name;
        fields["current_holding"] = parseFloat(item.balance_amount).toFixed(4);
        setFields(fields);
      }
    });
  };

  const [grossAmountInWords, setGrossAmountInWords] = useState("");
  const [netAmountInWords, setNetAmountInWords] = useState("");
  const [netAmountSeparator, setNetAmountSeparator] = useState("");
  const [grossAmountSeparator, setGrossAmountSeparator] = useState("");
  const [unitsSeparator, setUnitsSeparator] = useState("");
  const [unitsInWords, setUnitsInWord] = useState("");

  const setTotalRemainHolding = (amount, type) => {
    if (type === "NetAmount") {
      if (amount.length === 0) {
        setFields({
          ...fields,
          net_amount: amount,
        });
      } else {
        setFields({
          ...fields,
          net_amount: amount,
        });
      }
    } else if (type === "GrossAmount") {
      let unit =
        parseFloat(fields["applicable_offer_price"]) <= 0
          ? 0
          : parseFloat(amount) / parseFloat(fields["applicable_offer_price"]);
      let a = unit.toFixed(4).toString();

      if (amount.length === 0) {
        setFields({
          ...fields,
          gross_amount: amount,
          net_amount: amount,
        });
        setNetAmountSeparator("");
        setNetAmountInWords("");
        setGrossAmountSeparator("");
        setGrossAmountInWords("");
      } else {
        setFields({
          ...fields,
          gross_amount: amount,
          net_amount: amount,
          total_charges: "0",
        });
        let inwordNetAmount = inWords(amount);
        setNetAmountInWords(inwordNetAmount);
        let inwordGrossAmount = inWords(amount);
        setGrossAmountInWords(inwordGrossAmount);
        let grossAmountSeparator = numberWithCommas(amount);
        setGrossAmountSeparator(grossAmountSeparator);
        let netAmountSeparator = numberWithCommas(amount);
        setNetAmountSeparator(netAmountSeparator);
      }
    }
  };

  //set Current holding

  const setCurentHolding = (unit_value) => {
    //case to handle
    let total_Hold,
      gross_am = 0;
    let netamount = 0;
    if (fields.payment_type === "Receipt") {
      total_Hold = +fields["current_holding"] + +unit_value;
      gross_am = +unit_value * +fields["nav"];
      if (chechFieldDisplay(headLabel, "total_holding")) {
        fields["total_holding"] = parseFloat(total_Hold).toFixed(4);
      }
      if (chechFieldDisplay(headLabel, "nav")) {
        fields["gross_amount"] = gross_am.toFixed(4);
        fields["net_amount"] = gross_am.toFixed(4);
      }
      setAccTiltleName(
        (
          +fields["gross_amount"] +
          +fields["total_holding"] * +unit_value
        ).toString()
      );
    } else if (
      fields.payment_type === "Payment" ||
      headLabel === "unitconversion"
    ) {
      total_Hold = +fields["current_holding"] - +unit_value;
      gross_am = +unit_value * +fields["nav"];
      let red_load =
        unit_value *
        (+fields["nav"] - +fields["offer_price"]) *
        (1 - +fields["percentage_of_discount"] / 100);
      netamount =
        gross_am - red_load ||
        0 - parseFloat(fields["tax_cgt"].replace("", "0"));

      if (chechFieldDisplay(headLabel, "remain_holding")) {
        fields["remain_holding"] = parseFloat(total_Hold).toFixed(4);
      }
      if (chechFieldDisplay(headLabel, "nav")) {
        fields["gross_amount"] = gross_am.toFixed(4);
        fields["redemption_load"] = red_load.toFixed(4);
        fields["net_amount"] = netamount.toFixed(4);

        if (unit_value !== "") {
          let a = inWords(fields["gross_amount"]);
          let b = inWords(fields["net_amount"]);

          setGrossAmountInWords(a);
          setNetAmountInWords(b);

          //// separator
          let unitSepa = numberWithCommas(unit_value);
          let grossAmountSepa = numberWithCommas(fields["gross_amount"]);
          let netAmountSepa = numberWithCommas(fields["net_amount"]);
          setUnitsSeparator(unitSepa);
          setGrossAmountSeparator(grossAmountSepa);
          setNetAmountSeparator(netAmountSepa);
        } else {
          setGrossAmountInWords("");
          setNetAmountInWords("");
          setGrossAmountSeparator("");
          setNetAmountSeparator("");
          setUnitsSeparator("");
        }
      }
      setAccTiltleName(
        (
          +fields["total_holding"] / +fields["gross_amount"] +
          +unit_value
        ).toString()
      );
    } else {
    }
  };

  //retrun error border class
  const ErrorBorder = (value) => {
    if (value === true) {
      return "required-border";
    } else {
      return "";
    }
  };
  //

  const [viewBankBalanceModal, setViewBankBalanceModal] = useState(false);
  const [underStand, setUnderStand] = useState(false);
  // popup for bank balance
  const renderModalForBankBalance = () => {
    switch (viewBankBalanceModal) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            onHide={() => {
              setUnderStand(false);
              setViewBankBalanceModal(false);
            }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setUnderStand(false);
                  setViewBankBalanceModal(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">Bank Balance</h6>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <div></div> Balance
                    <input
                      type="number"
                      value={bankBalance || "0"}
                      readOnly
                      className="form-control w-100"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    Detail*
                    <input
                      type="text"
                      defaultValue={fields["detail"]}
                      className={"form-control w-100 "}
                      onChange={(e) => {
                        setFields({
                          ...fields,
                          detail: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-inline">
                    <div className="form-group mr-2">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          setUnderStand(!underStand);
                        }}
                      />
                    </div>
                    <span>I understand</span>
                  </div>
                </div>
              </div>
              {underStand === true ? (
                <>
                  <div className="row">
                    <div className="col-md-6">
                      <button
                        className="btn btn-primary btn-block"
                        disabled={Boolean(Loading)}
                        onClick={() => {
                          setFields({
                            ...fields,
                            low_balance_agree: "Yes",
                          });
                          createTransaction();
                        }}
                      >
                        {Loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Proceed</span>
                        )}
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button
                        className="btn btn-info btn-block"
                        onClick={() => {
                          setUnderStand(false);
                          setViewBankBalanceModal(false);
                        }}
                      >
                        <span>Cancel</span>
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {/* </div> */}
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };

  let [currentHolding, setCurrentHolding] = useState("");

  const setFolioNoDataForStep2 = (selected, funCode) => {
    count = count + 1;
    setAccTiltleName(`${selected}-${count}`);
    if (selected !== "Other") {
      // if user select any account from dropdown then data fillout
      unitHolderData.map((item, index) => {
        if (item.folio_no) {
          if (item.folio_no === selected) {
            setFields({
              ...fields,
              unitholder_name: item.name,
            });
            if (
              item.balance_unit !== "" &&
              item.balance_unit !== "[]" &&
              item.balance_unit !== undefined
            ) {
              let unitBlance = JSON.parse(item.balance_unit);
              if (unitBlance && typeof unitBlance !== "number") {
                const temp = unitBlance.filter((element) => {
                  if (element.fund_code.trim() === funCode) {
                    return element;
                  }
                });

                if (temp.length > 0) {
                  setAccTiltleName(
                    temp[0].fund_unit.toString().trim().toString()
                  );
                  setFields({
                    ...fields,
                    current_holding: parseFloat(
                      temp[0].fund_unit.toString().trim()
                    ).toFixed(4),
                  });
                  currentHolding = parseFloat(
                    temp[0].fund_unit.toString().trim()
                  ).toFixed(4);
                  setCurrentHolding(currentHolding);
                } else {
                  toast.error("Zero Units of selected Fund", {
                    position: "top-right",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
                  setAccTiltleName(`${temp.length + index}`);
                  setFields({
                    ...fields,
                    current_holding: "0.00",
                  });

                  currentHolding = "0.00";
                  setCurrentHolding(currentHolding);
                }
              }
            } else {
              //empty
              toast.error("Zero Units of selected Fund", {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
              });

              setFields({
                ...fields,
                current_holding: "0.00",
              });
              currentHolding = "0.00";
              setCurrentHolding(currentHolding);
              count = count + 1;
              setAccTiltleName(`${selected}-${count}-${selected}`);
            }
          }
        }
      });
    } else {
      setFields({
        ...fields,
        current_holding: "0.00",
      });
      currentHolding = "0.00";
      setCurrentHolding(currentHolding);
      setAccTiltleName(`${count}-${selected}`);
    }
  };

  const [finishFlag, setFinishFlag] = useState(false);

  React.useEffect(() => {
    if (finishFlag) {
      let data: string = sessionStorage.getItem("Txn1") || "";
      let prevTxnData = JSON.parse(data);
      // for conversion of units 2nd step
      setFolioNoDataForStep2(fields["folio_no"], prevTxnData.counter_type);
      setFields({
        ...fields,
        fund_code: prevTxnData.counter_type,
        fund_account: prevTxnData.counter_account_type,
        account_title: prevTxnData.counter_account_title,
        account_no: prevTxnData.counter_account_number,
        bank: prevTxnData.counter_bank,
        branch: prevTxnData.counter_branch,
        counter_type: prevTxnData.fund_code,
        counter_account_type: prevTxnData.fund_account,
        counter_account_title: prevTxnData.account_title,
        counter_account_number: prevTxnData.account_no,
        counter_bank: prevTxnData.bank,
        counter_branch: prevTxnData.branch,
        conversion_date: prevTxnData.redemption_date,
        redemption_date: "",
        units: "",
        nav: "",
        percentage_of_discount: "",
        load_per_unit: "",
        offer_price: "",
        applicable_offer_price: "",
        current_holding: currentHolding,
        total_holding: "",
        redemption_load: "",
        tax_cgt: "",
        zakat_amount: "",
        gross_amount: prevTxnData.net_amount,
        net_amount: 0,
        txnr_type: "conversionin",
        payment_type: "Receipt",
      });
      setUnitsSeparator("");
      setGrossAmountSeparator("");
      setGrossAmountInWords("");
      setNetAmountSeparator("");
      setNetAmountInWords("");
    }
  }, [finishFlag]);

  const Finish = async () => {
    setLoading(true);
    const isValid = await validate(); // check validation for Fields Data
    if (isValid) {
      if (
        parseFloat(fields["net_amount"]) < 0 ||
        parseFloat(fields["gross_amount"]) < 0 ||
        parseFloat(fields["units"]) < 0 ||
        parseFloat(fields["remain_holding"]) < 0
      ) {
        toast.error("Amounts or units or remain holding are negative");
      } else {
        let data: string = sessionStorage.getItem("Txn1") || "";
        let txnsData: any = [];
        txnsData.push(JSON.parse(data));

        txnsData[0].folio_no = txnsData[0].folio_no.replaceAll(
          txnsData[0].amc_code + "-",
          ""
        );
        txnsData[0].folio_no =
          txnsData[0].amc_code + "-" + txnsData[0].folio_no;

        fields["folio_no"] = fields["folio_no"].replaceAll(
          fields["amc_code"] + "-",
          ""
        );
        fields["folio_no"] = fields["amc_code"] + "-" + fields["folio_no"];
        txnsData.push(fields);
        const response = await addConversionOfUnitsTransaction(email, txnsData);
        sessionStorage.removeItem("Txn1");
        sessionStorage.setItem("last_id", response.data.txn_id);
        toast.success(response.data.message);
        setTimeout(() => {
          history.replace(`/admin/transaction-types`);
        }, 3000);
      }
    } else {
      setErrorShow(true);
      toast.error("Kindly Fill All the Fields");
    }
    setLoading(false);
  };

  React.useEffect(() => {
    setViewModalAddNewUnitHolder(false);
  }, [propsState]);

  const renderModalAddNewUnitHolder = () => {
    switch (viewModalAddNewHolder) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="xl"
            backdrop={true}
            onHide={() => {
              setViewModalAddNewUnitHolder(false);
            }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setViewModalAddNewUnitHolder(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">Add UnitHolder</h6>
            </div>
            <div className="modal-body">
              <>
                <AddUnitHolder setPropState={setPropsState} />
              </>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund = allFunds.find(
      (item) => item?.symbol_code === fields["fund_code"]
    );
    return selectedFund && selectedFund.nature === "Special Managed Account"
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code}) - SMA`,
        }
      : selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
        }
      : null;
  }, [allFunds, fields["fund_code"], allStateDropdown?.fund_name]);

  const selectedModeofPayment = React.useMemo(() => {
    return fields["mode_of_payment"]
      ? {
          value: fields["mode_of_payment"],
          label: fields["mode_of_payment"],
        }
      : null;
  }, [MOPData, fields["mode_of_payment"]]);

  const selectedInstrumentType = React.useMemo(() => {
    return fields["instrument_type"]
      ? {
          value: fields["instrument_type"],
          label: fields["instrument_type"],
        }
      : null;
  }, [iTypeData, fields["instrument_type"]]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
        ? "hsla(291, 64%, 42%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
        ? "#2b3553"
        : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer />
              <div className="">
                <div className="input-holder">
                  <div className="row">
                    <h4 className=" card-title">
                      <i
                        className="fa fa-angle-left mr-2 ml-3 mt-1 pointer"
                        onClick={() => {
                          history.goBack();
                        }}
                      ></i>
                      {CapTxnType(headLabel)} Journal Voucher
                    </h4>
                  </div>

                  {finishFlag === true && (
                    <span>
                      Step<span className="text-primary"> 2</span> of 2
                    </span>
                  )}
                </div>
                <div className=" ">
                  <Row>
                    <Col>
                      <div className="card">
                        <div className="card-header">
                          <h4 className="card-title">Instruction</h4>
                        </div>
                        <div className="card-body">
                          <div>
                            <div className="form-group " data-tip="Select Fund">
                              Fund Name*
                              <ReactTooltip
                                textColor="white"
                                backgroundColor="black"
                                effect="float"
                              />
                              {accFundLoading ? (
                                <div className="form-control w-100">
                                  <i className="fa fa-spinner fa-spin fa-1x"></i>
                                </div>
                              ) : (
                                <Select
                                  className={ErrorBorder(fields["fund_code"])}
                                  value={selectedFundName}
                                  label={
                                    fundCheck ? "No Fund Found" : "Select Fund"
                                  }
                                  onChange={(e) => {
                                    setFund(e?.value);
                                    fields["fund_code"] = e?.value;
                                    setFields(fields);

                                    clearFundAccountFields();

                                    setFundCodeError(false);
                                    setAllStateDropdown((prev) => {
                                      return {
                                        ...prev,
                                        fund_name:
                                          allStateDropdown?.fund_name + 1,
                                      };
                                    });
                                  }}
                                  menuPortalTarget={document.body}
                                  menuShouldBlockScroll={true}
                                  isClearable={true}
                                  isSearchable={true}
                                  name="color"
                                  options={renderFundsDropdown()}
                                  styles={customStyles}
                                />
                              )}
                            </div>
                            <div className="form-group">
                              <div>Instruction Date</div>
                              <input
                                id="input_Data"
                                type="date"
                                value={fields["instruction_date"]}
                                readOnly
                                className={
                                  "form-control input_date w-100 " +
                                  ErrorBorder(instructionDateError)
                                }
                                onChange={(e) => {
                                  setFields({
                                    ...fields,
                                    instruction_date: e.target.value,
                                  });
                                  setInstructionDateError(false);
                                }}
                              />
                            </div>
                            <div className="form-group">
                              <div>Settlement Date</div>
                              <input
                                id="input_Data"
                                type="date"
                                value={fields["execution_date"]}
                                readOnly={finishFlag}
                                className={
                                  "form-control input_date w-100" +
                                  ErrorBorder(settlementDateError)
                                }
                                onChange={(e) => {
                                  setFields({
                                    ...fields,
                                    execution_date: e.target.value,
                                    settlement_date: e.target.value,
                                  });
                                  setSettelementDateError(false);
                                }}
                              />
                            </div>
                            {headLabel !== "pledgedin" &&
                              headLabel !== "pledgedout" && (
                                <div className="form-group">
                                  <div>Mode of Payment*</div>
                                  <Select
                                    className={ErrorBorder(modeOfPaymentError)}
                                    disabled={finishFlag}
                                    value={selectedModeofPayment}
                                    label={"Select Payment"}
                                    onChange={(e) => {
                                      setFields({
                                        ...fields,
                                        mode_of_payment: e?.value,
                                      });
                                      setModeOfPaymentError(false);
                                    }}
                                    menuPortalTarget={document.body}
                                    menuShouldBlockScroll={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    options={renderModeOfPayments()}
                                    styles={customStyles}
                                  />
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </Col>
                    {headLabel !== "pledgedin" &&
                      headLabel !== "pledgedout" && (
                        <Col className="col-md-4">
                          <div className="card">
                            <div className="card-header">
                              <h4 className="card-title">Instrument</h4>
                            </div>
                            <div className="card-body">
                              <div>
                                <div className="form-group">
                                  <div>Instrument Type</div>
                                  <Select
                                    className={ErrorBorder(instrumentTypeError)}
                                    value={selectedInstrumentType}
                                    label={"Select Type"}
                                    onChange={(e) => {
                                      setFields({
                                        ...fields,
                                        instrument_type: e?.value,
                                      });
                                      setInstrumentTypeError(false);
                                    }}
                                    menuPortalTarget={document.body}
                                    menuShouldBlockScroll={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    options={renderiTypeDataDropdown()}
                                    styles={customStyles}
                                  />
                                </div>

                                <>
                                  <div className="form-group">
                                    <div>Instrument No./Reference No</div>
                                    <input
                                      defaultValue={fields["instrument_no"]}
                                      type="text"
                                      className={"form-control w-100 "}
                                      onChange={(e) => {
                                        setFields({
                                          ...fields,
                                          instrument_no: e.target.value,
                                        });
                                      }}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <div>Instrument Date / Deposit Date</div>
                                    <input
                                      id="input_Data"
                                      type="date"
                                      defaultValue={fields["instrument_date"]}
                                      className={
                                        "form-control input_date w-100 " +
                                        ErrorBorder(fields["instrument_date"])
                                      }
                                      onChange={(e) => {
                                        setFields({
                                          ...fields,
                                          instrument_date: e.target.value,
                                        });
                                      }}
                                    />
                                  </div>
                                </>
                              </div>
                            </div>
                          </div>
                        </Col>
                      )}

                    <Col>
                      <div className="card">
                        <div className="card-header d-flex justify-content-between">
                          <div>
                            <h4 className="card-title">Difference</h4>
                          </div>
                        </div>
                        <div className="card-body">
                          <input
                            type="text"
                            className="form-control w-100"
                            value={numberWithCommas(
                              parseInt(totalDebit || "0") -
                                parseInt(totalCredit || "0")
                            )}
                            readOnly
                          />
                        </div>
                        <div className="card-footer">
                          <div className="form-group">
                            <small>
                              Difference between debit & credit should be 0
                            </small>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <div className="card">
                        <div className="card-header d-flex justify-content-between">
                          <div>
                            <h4 className="card-title">Debit</h4>
                          </div>
                          <div>
                            <button
                              className=" btn-round btn-icon btn btn-success"
                              onClick={() => {
                                setViewAddDebitModal(true);
                              }}
                            >
                              <i
                                style={{
                                  transform: "translate(-50%, -50%)",
                                }}
                                className="fa fa-plus"
                              ></i>
                            </button>
                          </div>
                        </div>
                        <div className="card-body">
                          {debitFormData ? (
                            <table className="table" id="myTable">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Ledger Code</th>
                                  <th>Ledger Name</th>
                                  <th className="text-center">Amount</th>
                                  <th>Description</th>
                                  <th>Invoice Number</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {debitFormData.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <small>
                                          {item.ledger
                                            .split("-")[0]
                                            .replace(/\s+/g, "")}
                                        </small>
                                      </td>
                                      <td>
                                        <small>
                                          {item.ledger.split("-")[1].trim()}
                                        </small>
                                      </td>

                                      <td className="text-center">
                                        {numberWithCommas(item.amount || 0)}
                                      </td>
                                      <td>{item.description}</td>
                                      <td>{item.invoiceNumber}</td>
                                      <td>
                                        <div className="d-flex justify-content-around">
                                          <i
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setViewDebitIndex(index);
                                              setViewViewDebitModal(true);
                                            }}
                                            className="fa fa-eye"
                                          />

                                          <i
                                            className="tim-icons icon-pencil"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setEditDebitIndex(index);

                                              setValueSelectedLedgerDebit(
                                                item.ledger
                                              );
                                              setDescriptionDebit(
                                                item.description
                                              );
                                              setAmountDebit(item.amount);
                                              setInvoiceNumberDebit(
                                                item.invoiceNumber
                                              );
                                              setViewAddDebitModal(true);
                                            }}
                                          />

                                          <i
                                            className="tim-icons icon-simple-remove"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              handleDebitDelete(
                                                item.ledger,
                                                item.amount,
                                                index
                                              );
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          ) : null}
                        </div>
                        <div className="card-footer">
                          <div className="form-group">
                            {/* <div>Execution Date</div> */}
                            <div>Total Debit</div>
                            <input
                              type="text"
                              placeholder="Total Debit"
                              readOnly
                              value={numberWithCommas(totalDebit)}
                              className={
                                "form-control w-100" + ErrorBorder(totalDebit)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col>
                      <div className="card">
                        <div className="card-header d-flex justify-content-between">
                          <div>
                            <h4 className="card-title">Credit</h4>
                          </div>
                          <div>
                            <button
                              className=" btn-round btn-icon btn btn-success"
                              onClick={() => {
                                setViewAddCreditModal(true);
                              }}
                            >
                              {" "}
                              <i
                                style={{
                                  transform: "translate(-50%, -50%)",
                                }}
                                className="fa fa-plus"
                              ></i>{" "}
                            </button>
                          </div>
                        </div>
                        <div className="card-body">
                          {creditFormData ? (
                            <table className="table" id="myTable">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Ledger Code</th>
                                  <th>Ledger Name</th>
                                  <th className="text-center">Amount </th>
                                  <th>Description</th>
                                  <th>Invoice Number</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {creditFormData.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <small>
                                          {item.ledger
                                            .split("-")[0]
                                            .replace(/\s+/g, "")}
                                        </small>
                                      </td>
                                      <td>
                                        <small>
                                          {item.ledger.split("-")[1]?.trim()}
                                        </small>
                                      </td>

                                      <td className="text-center">
                                        {numberWithCommas(item.amount)}
                                      </td>
                                      <td>{item.description}</td>
                                      <td>{item.invoiceNumber}</td>
                                      <td>
                                        <div className="d-flex justify-content-around">
                                          <i
                                            className="fa fa-eye"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setViewCreditIndex(index);
                                              setViewViewCreditModal(true);
                                            }}
                                          />

                                          <i
                                            className="tim-icons icon-pencil"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setEditCreditIndex(index);

                                              setValueSelectedLedgerCredit(
                                                item.ledger
                                              );
                                              setInputValueSelectedLedgerCredit(
                                                item.ledger
                                              );
                                              setSelectedLedgerCredit(
                                                item.ledger
                                              );
                                              setDescriptionCredit(
                                                item.description
                                              );
                                              setAmountCredit(item.amount);
                                              setInvoiceNumberCredit(
                                                item.invoiceNumber
                                              );
                                              setViewAddCreditModal(true);
                                            }}
                                          />

                                          <i
                                            className="tim-icons icon-simple-remove"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              handleCreditDelete(
                                                item.ledger,
                                                item.amount,
                                                index
                                              );
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          ) : null}
                        </div>
                        <div className="card-footer">
                          <div className="form-group">
                            <div>Total Credit</div>
                            <input
                              type="text"
                              placeholder="Invoice Number"
                              readOnly
                              value={numberWithCommas(totalCredit)}
                              className={
                                "form-control w-100" + ErrorBorder(totalCredit)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {headLabel !== "unitconversion" && finishFlag == false && (
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            handleCreate();
                          }}
                          disabled={
                            Boolean(Loading) ||
                            parseInt(totalCredit) - parseInt(totalDebit) !==
                              0 ||
                            debitFormData.length === 0 ||
                            creditFormData.length === 0
                          }
                        >
                          {Loading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Loading...</span>
                            </>
                          ) : (
                            <span>
                              {tx === "cashdividend" ? "Update" : "Create"}
                            </span>
                          )}
                        </button>
                      </div>
                    </div>
                  )}

                  {finishFlag == true && (
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            // createTransaction();
                            Finish();
                          }}
                          disabled={Boolean(Loading)}
                        >
                          {Loading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Loading...</span>
                            </>
                          ) : (
                            <span>{flag ? "Update" : "Finish"}</span>
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {renderModalForAddCredit()}

                {renderModalForViewCredit(viewCreditIndex)}
                {renderModalForAddDebit()}
                {renderModalForViewDebit(viewDebitIndex)}

                {renderModalForBankBalance()}
                {renderModalAddNewUnitHolder()}
              </div>
              <div style={{ display: "none" }}>{accTilteName}</div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Vouchers;
